<template>
  <CatNicknameDialogBase :on-click-outside="onClickOutside">
    <template #header>
      <div class="dialog-header">
        <div class="cat-display">
          <cat-icon size="large" :clickable="false" :writer-type="assistantCat?.assistantCatType" />
        </div>
        <div class="success-message">
          <p class="reaction-message">{{ reactionMessage }}</p>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="dialog-footer">
        <button class="button primary" @click="onOk">{{ $t("myPage.catNicknameSuccessDialog.okButton") }}</button>
      </div>
    </template>
  </CatNicknameDialogBase>
</template>

<script lang="ts">
import Vue from "vue";
import CatIcon from "@/components/atoms/CatIcon.vue";
import CatNicknameDialogBase from "@/components/ui/CatNicknameDialogBase.vue";
import { AssistantCat } from "@/lib/models/assistantCat";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CatIcon,
    CatNicknameDialogBase,
  },

  props: {
    assistantCat: {
      type: Object as () => AssistantCat | null,
      default: null,
    },
    reactionMessage: {
      type: String,
      default: "",
    },
  },

  methods: {
    onOk() {
      this.$emit("ok");
    },

    onClickOutside() {
      this.onOk();
    },
  },
});

interface Data {}

interface Methods {
  onOk: () => void;
  onClickOutside: () => void;
}

interface Computed {}

interface Props {
  assistantCat: AssistantCat | null;
  reactionMessage: string;
}
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.dialog-header {
  text-align: center;

  .cat-display {
    margin-bottom: 15px;
    display: flex;
    justify-content: center;
  }

  .success-message {
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    color: var(--color-text-normal);

    .reaction-message {
      white-space: pre-line;
      margin: 0;
    }
  }
}

.dialog-footer {
  margin: 20px -20px 0 -20px;
  border-top: 1px solid var(--color-border);
  display: flex;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  overflow: hidden;

  .button {
    width: 100%;
    height: 44px;
    border: none;
    background-color: transparent;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &.primary {
      color: var(--color-primary);
    }
  }
}

@media (max-width: 576px) {
  .dialog-footer {
    margin: 15px -15px 0 -15px;
  }
}
</style>
